export default "__VITE_ASSET__Bw5labCz__"